import {
  Button,
  ButtonSize,
  ButtonStyles,
  ButtonTypes,
  ButtonWidth,
  Modal,
  useTranslation,
} from '@nextgen-web-framework/all';
import Signature from '../Signature/Signature';
import { SignatureModalProps } from './types/propTypes';

const SignatureModal = ({
  onSignatureConfirm,
  signatureEmpty,
  onSignatureClear,
  onSignatureClose,
  saveSignature,
  signatureDone,
  signatureCleared,
  onSignatureTouched,
}: SignatureModalProps) => {
  const t = useTranslation();

  return (
    <div>
      <Modal
        headline={t('profile.RegistrationPersonalDetailsStep.signature.heading')}
        primaryButtonLabel={''}
        primaryButton={
          <Button
            title={t('profile.RegistrationPersonalDetailsStep.signature.confirm')}
            type={ButtonTypes.SUBMIT}
            data-testid="signature-modal-confirm-id"
            buttonStyle={ButtonStyles.SOLID}
            size={ButtonSize.MEDIUM}
            onClick={onSignatureConfirm}
            buttonWidth={ButtonWidth.FULL_WIDTH}
            disabled={signatureEmpty}
          />
        }
        secondaryButtonLabel={''}
        secondaryButton={
          <Button
            title={t('profile.RegistrationPersonalDetailsStep.signature.clear')}
            type={ButtonTypes.RESET}
            data-testid="signature-modal-clear-id"
            buttonStyle={ButtonStyles.OUTLINE}
            size={ButtonSize.MEDIUM}
            buttonWidth={ButtonWidth.FULL_WIDTH}
            onClick={onSignatureClear}
            disabled={signatureEmpty}
          />
        }
        onClose={onSignatureClose}
      >
        <Signature
          callback={saveSignature}
          completed={signatureDone}
          cleared={signatureCleared}
          isTouched={onSignatureTouched}
        />
      </Modal>
    </div>
  );
};

export default SignatureModal;
